import { Box, Flex, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import WidgetBox from "components/elements/WidgetBox/widget-box";
// import { formatLoanStatus } from "components/elements/StatusBadge";
import { LoansContext } from "providers/loans";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useState, useEffect, useContext } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Label, Legend } from "recharts";

const renderLegend = (props: any) => {
  const { payload } = props;
  return (
    <UnorderedList w="100%" listStyleType="none" m="0" p="0">
      {payload.map((entry: any, index: number) =>
        entry.payload.value ? (
          <ListItem key={`item-${index}`} my="20px">
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center">
                <Box bg={entry.color} width="20px" height="20px" borderRadius="6px" mr="10px"></Box>
                <Text color="#171B1E" fontWeight="500" fontSize="16px">
                  {entry.value}
                </Text>
              </Flex>
              <Text color="#171B1E" fontWeight="500" fontSize="16px">
                {entry.payload.value}
              </Text>
            </Flex>
          </ListItem>
        ) : null
      )}
    </UnorderedList>
  );
};

const LoanStatusPie = () => {
  const { user } = useTenant();
  const { loans } = useContext(LoansContext);

  const [chartData, setChartData] = useState<
    {
      name: string;
      value: number;
    }[]
  >([]);

  useEffect(() => {
    setChartData(
      user.company.statuses.map((status: any) => ({
        name: status.label,
        value: loans.filter((loan: any) => loan.status.id === status.id).length,
      }))
    );
  }, [loans]);

  return (
    <WidgetBox>
      <Text fontWeight="600" fontSize="14px" mb="35px">
        Loan Status
      </Text>
      <Box height="900px">
        <ResponsiveContainer>
          <PieChart margin={{ top: 0, left: 0, right: 0, bottom: 0 }}>
            <Label value="any text" position="center" />
            <Pie
              data={chartData}
              // cx="%"
              // cy={80}
              innerRadius="82%"
              outerRadius="100%"
              fill="#8884d8"
              cornerRadius={100}
              paddingAngle={2}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    user.company.statuses.map((status: any) => status.color)[
                      index % user.company.statuses.length
                    ]
                  }
                />
              ))}
            </Pie>
            <Legend
              layout="vertical"
              verticalAlign="bottom"
              align="center"
              content={renderLegend}
              wrapperStyle={{ width: "100%" }}
              margin={{ top: 0, left: 0, right: 0, bottom: 0 }}
            />
          </PieChart>
        </ResponsiveContainer>
      </Box>
    </WidgetBox>
  );
};

export default LoanStatusPie;
